<app-page pageTitle="attribution_overview.attribution_overview"
          template="dashboard"
          [contentFullHeight]="false"
          [loader]="false">
  <ng-container actions>
    <app-autocorrect-consent-button></app-autocorrect-consent-button>
  </ng-container>
  <ng-container parameters>
    <app-card>
      <app-report-params [paramsConfigs]="paramsConfigs$ | async"
                         [paramsDropdownConfigs]="paramsDropdownConfigs$ | async"
                         [actionsConfigs]="actionsConfigs$ | async"></app-report-params>
    </app-card>
  </ng-container>
  <ng-container content>
    <div [ngClass]="{ filter: (loading$ | async) || (allLoading$ | async) }">
      <div class="grid-container grid-container-4 mb-20 mt-20">
        <app-card>
          <div class="fs-28 text-ellipsis text-center overview-big-number">
            <span class="text-ellipsis">{{ (totalConversions$ | async) | nullValue }}</span>
          </div>
          <div class="font-bold text-md text-center text-secondary uppercase tracking-wider text-ellipsis h-20 text-ellipsis overview-big-number-label">
            <span class="text-ellipsis">{{ 'attribution_overview.total_conversions' | translate }}</span>
          </div>
        </app-card>
      </div>
      <div id="charts-container" class="display-grid mb-20">
        <app-card>
          <div class="grid-container grid-container-2 mb-20">
            <div class="overflow-hidden">
              <div class="fs-28 text-ellipsis text-center overview-big-number">
                <span class="text-ellipsis">{{ (conversionMonotouch$ | async) | nullValue }}</span>
              </div>
              <div class="text-ellipsis text-center overview-big-number-percent">
                <span class="text-ellipsis">{{ (conversionMonotouchPercentage$ | async | percent) | nullValue }}</span>
              </div>
              <div class="font-bold text-md uppercase text-secondary tracking-wider text-ellipsis h-20 text-center overview-big-number-label">
                <span class="text-ellipsis">{{ 'attribution_overview.conv_monotouch' | translate }}</span>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="fs-28 text-ellipsis text-center overview-big-number">
                <span class="text-ellipsis">{{ (conversionMultitouch$ | async) | nullValue }}</span>
              </div>
              <div class="text-ellipsis text-center overview-big-number-percent">
                <span class="text-ellipsis">{{ (conversionMultitouchPercentage$ | async | percent) | nullValue }}</span>
              </div>
              <div class="font-bold text-md uppercase text-secondary tracking-wider text-ellipsis h-20 text-center overview-big-number-label">
                <span class="text-ellipsis">{{ 'attribution_overview.conv_multitouch' | translate }}</span>
              </div>
            </div>
          </div>
          <div id="chartMonoMultitouch" #chartMonoMultitouch echarts [options]="pieChartOptionMonoMultitouch$ | async"></div>
        </app-card>
        <app-card>
          <div class="grid-container grid-container-2 mb-20">
            <div class="overflow-hidden">
              <div class="fs-28 text-ellipsis text-center overview-big-number">
                <span class="text-ellipsis">{{ (conversionMonochannel$ | async) | nullValue }}</span>
              </div>
              <div class="text-ellipsis text-center overview-big-number-percent">
                <span class="text-ellipsis">{{ (conversionMonochannelPercentage$ | async | percent) | nullValue }}</span>
              </div>
              <div class="font-bold text-md uppercase text-secondary tracking-wider text-ellipsis h-20 text-center overview-big-number-label">
                <span class="text-ellipsis">{{ 'attribution_overview.conv_monochannel' | translate }}</span>
              </div>
            </div>
            <div class="overflow-hidden">
              <div class="fs-28 text-ellipsis text-center overview-big-number">
                <span class="text-ellipsis">{{ (conversionMultichannel$ | async) | nullValue }}</span>
              </div>
              <div class="text-ellipsis text-center overview-big-number-percent">
                <span class="text-ellipsis">{{ (conversionMultichannelPercentage$ | async | percent) | nullValue }}</span>
              </div>
              <div class="font-bold text-md uppercase text-secondary tracking-wider text-ellipsis h-20 text-center overview-big-number-label">
                <span class="text-ellipsis">{{ 'attribution_overview.conv_multichannel' | translate }}</span>
              </div>
            </div>
          </div>
          <div id="chartMonoMultichannel" #chartMonoMultichannel echarts [options]="pieChartOptionMonoMultichannel$ | async"></div>
        </app-card>
      </div>
      <app-card class="mb-20">
        <div class="mb-10 font-bold text-md uppercase tracking-wider text-ellipsis h-20 display-flex flex-align-center overview-big-number-title">
          {{ 'attribution_overview.all_conversions' | translate }}
        </div>
        <div class="grid-container grid-container-3 overflow-hidden">
          <div class="overflow-hidden">
            <div class="fs-28 text-ellipsis text-center overview-big-number">
              <span class="text-ellipsis">{{ (allConversionsAvgDaysToConversion$ | async) | nullValue }}</span>
            </div>
            <div class="font-bold text-md text-secondary uppercase tracking-wider text-ellipsis text-center overview-big-number-label">
              <span class="text-ellipsis">{{ 'attribution_overview.avg_days_to_conv' | translate }}</span>
            </div>
          </div>
          <div class="overflow-hidden">
            <div class="fs-28 text-ellipsis text-center overview-big-number">
              <span class="text-ellipsis">{{ (allConversionsAvgNumbersOfChannels$ | async) | nullValue }}</span>
            </div>
            <div class="font-bold text-md text-secondary uppercase tracking-wider text-ellipsis text-ellipsis text-center overview-big-number-label">
              <span class="text-ellipsis">{{ 'attribution_overview.avg_numbers_of_channels' | translate }}</span>
            </div>
          </div>
          <div class="overflow-hidden">
            <div class="fs-28 text-ellipsis text-center overview-big-number">
              <span class="text-ellipsis">{{ (allConversionsAvgNumbersTouchpoints$ | async) | nullValue }}</span>
            </div>
            <div class="font-bold text-md text-secondary uppercase tracking-wider text-ellipsis text-ellipsis text-center overview-big-number-label">
              <span class="text-ellipsis">{{ 'attribution_overview.avg_numbers_of_touchpoints' | translate }}</span>
            </div>
          </div>
        </div>
      </app-card>
      <app-card class="mb-20">
        <div class="mb-10 font-bold text-md uppercase tracking-wider text-ellipsis h-20 display-flex flex-align-center overview-big-number-title">
          {{ 'attribution_overview.multitouchpoint_conv' | translate }}
        </div>
        <div class="grid-container grid-container-3">
          <div class="overflow-hidden">
            <div class="fs-28 text-ellipsis text-center overview-big-number">
              <span class="text-ellipsis">{{ (multitouchpointAvgDaysToConversion$ | async) | nullValue }}</span>
            </div>
            <div class="font-bold text-md text-secondary uppercase tracking-wider text-ellipsis text-center overview-big-number-label">
              <span class="text-ellipsis">{{ 'attribution_overview.avg_days_to_conv' | translate }}</span>
            </div>
          </div>
          <div class="overflow-hidden">
            <div class="fs-28 text-ellipsis text-center overview-big-number">
              <span class="text-ellipsis">{{ (multitouchpointAvgNumbersOfChannels$ | async) | nullValue }}</span>
            </div>
            <div class="font-bold text-md text-secondary uppercase tracking-wider text-ellipsis text-center overview-big-number-label">
              <span class="text-ellipsis">{{ 'attribution_overview.avg_numbers_of_channels' | translate }}</span>
            </div>
          </div>
          <div class="overflow-hidden">
            <div class="fs-28 text-ellipsis text-center overview-big-number">
              <span class="text-ellipsis">{{ (multitouchpointAvgNumbersTouchpoints$ | async) | nullValue }}</span>
            </div>
            <div class="font-bold text-md text-secondary uppercase tracking-wider text-ellipsis text-center overview-big-number-label">
              <span class="text-ellipsis">{{ 'attribution_overview.avg_numbers_of_touchpoints' | translate }}</span>
            </div>
          </div>
        </div>
      </app-card>
      <app-card class="mb-20">
        <div class="mb-10 font-bold text-md uppercase tracking-wider text-ellipsis h-20 display-flex flex-align-center overview-big-number-title">
          {{ 'attribution_overview.multitouchpoint_conv_paid' | translate }}
        </div>
        <div class="grid-container grid-container-3">
          <div class="overflow-hidden">
            <div class="fs-28 text-ellipsis text-center overview-big-number">
              <span class="text-ellipsis">{{ (multitouchpointPaidAvgDaysToConversion$ | async) | nullValue }}</span>
            </div>
            <div class="font-bold text-md text-secondary uppercase tracking-wider text-ellipsis text-center overview-big-number-label">
              <span class="text-ellipsis">{{ 'attribution_overview.avg_days_to_conv' | translate }}</span>
            </div>
          </div>
          <div class="overflow-hidden">
            <div class="fs-28 text-ellipsis text-center overview-big-number">
              <span class="text-ellipsis">{{ (multitouchpointPaidAvgNumbersOfChannels$ | async) | nullValue }}</span>
            </div>
            <div class="font-bold text-md text-secondary uppercase tracking-wider text-ellipsis text-center overview-big-number-label">
              <span class="text-ellipsis">{{ 'attribution_overview.avg_numbers_of_channels' | translate }}</span>
            </div>
          </div>
          <div class="overflow-hidden">
            <div class="fs-28 text-ellipsis text-center overview-big-number">
              <span class="text-ellipsis">{{ (multitouchpointPaidAvgNumbersTouchpoints$ | async) | nullValue }}</span>
            </div>
            <div class="font-bold text-md text-secondary uppercase tracking-wider text-ellipsis text-center overview-big-number-label">
              <span class="text-ellipsis">{{ 'attribution_overview.avg_numbers_of_touchpoints' | translate }}</span>
            </div>
          </div>
        </div>
      </app-card>
      <app-card class="mb-20 padding-0">
        <div class="p-1rem">
          <div class="display-flex">
            <div class="flex-grow">
              <mat-button-toggle-group [formControl]="channelsTouchpointsTimeCtrl">
                <mat-button-toggle value="time" [disabled]="!(loaded$ | async)">{{ 'attribution_overview.time' | translate }}</mat-button-toggle>
                <mat-button-toggle value="touchpoints" [disabled]="!(loaded$ | async)">{{ 'attribution_overview.touchpoints' | translate }}</mat-button-toggle>
                <mat-button-toggle value="channels" [disabled]="!(loaded$ | async)">{{ 'attribution_overview.channels' | translate }}</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <div>
              <mat-button-toggle-group [formControl]="allPaidCtrl">
                <mat-button-toggle value="all" [disabled]="!(loaded$ | async)">{{ 'attribution_overview.all' | translate }}</mat-button-toggle>
                <mat-button-toggle value="paid" [disabled]="!(loaded$ | async)">{{ 'attribution_overview.paid' | translate }}</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          <div class="pt-20 pb-20">
            <div #chartTable echarts [options]="pieChartOptionTable$ | async"></div>
          </div>
        </div>
        <div id="table-container">
          <mat-tab-group class="full-height full-width" #matTabGroup>
            <mat-tab>
              <app-ag-grid [columnDefs]="tableTimeDefs"
                           [rowData]="tableTimeData$ | async"
                           *ngIf="active && matTabGroup.selectedIndex === 0"></app-ag-grid>
            </mat-tab>
            <mat-tab>
              <app-ag-grid [columnDefs]="tableTouchpointsDefs"
                           [rowData]="tableTouchpointsData$ | async"
                           *ngIf="active && matTabGroup.selectedIndex === 1"></app-ag-grid>
            </mat-tab>
            <mat-tab>
              <app-ag-grid [columnDefs]="tableChannelsDefs"
                           [rowData]="tableChannelsData$ | async"
                           *ngIf="active && matTabGroup.selectedIndex === 2"></app-ag-grid>
            </mat-tab>
            <ng-template #cellPercent let-row>
              {{ row.percent | percent }}
            </ng-template>
            <ng-template #cellName let-row>
              {{ row.name | translate }}
            </ng-template>
          </mat-tab-group>
        </div>
      </app-card>
    </div>
  </ng-container>
</app-page>
